export default __webpack_public_path__ + "static/media/FIU_Engagement.5e7af57a.svg";